import React, { Component, Fragment } from 'react';

import Setting from '../../Setting/Setting';
import DesktopCalendar from './DesktopCalendar/DesktopCalendar';
import Header from './Header/Header';
import Search from './Search/Search';
import Filter from './Filter/Filter';
import Panel from '../../Panel/Panel';

import './Desktop.css';

export default class Desktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSetting: false,
      openPanel: false,
    }
  }

  setOpenSetting = () => {
    this.setState({
      openSetting: !this.state.openSetting,
    })
  }

  setOpenPanel = () => {
    this.setState({
      openPanel: !this.state.openPanel,
    })
  }

  render() {
    const { events, doneList, religious_times, monasebat, selectedDay, setSelectedDay, addDone, deleteDone, filters } = this.props;
    return (
      <div className="desktop-box">
        <div className={this.state.openSetting || this.state.openPanel ? 'desktop phone-number-blur d-flex' : 'desktop d-flex'}>
          <div className="desktop__right d-flex flex-column">
            <div className="desktop__right--top">
              <DesktopCalendar setSelectedDay={setSelectedDay} selectedDay={selectedDay} monasebat={monasebat} />
            </div>
            <div className="desktop__right--middle d-flex">
              <Search />
            </div>
            <div className="desktop__right--bottom">
              <Filter filters={filters} />
            </div>
          </div>
          <div className="desktop__left">
            <Header setOpenSetting={this.setOpenSetting} setOpenPanel={this.setOpenPanel} />
          </div>
        </div>
        <Fragment>
          {
            this.state.openSetting ?
              <Setting setOpenSetting={this.setOpenSetting} /> : null
          }

          {
            this.state.openPanel ?
              <Panel setOpenPanel={this.setOpenPanel} /> : null
          }
        </Fragment>
      </div>
    );
  }
}